/*nvm use 8
gulp js
 */
(function() {
	'use strict';

	angular
		.module('diplomaApp')
		.controller('accessoryController', ['$scope', '$http', '$location', '$log', '$filter', '$timeout', 'dpText', 'dpHelper', accessoryController]);

	function accessoryController($scope, $http, $location, $log, $filter, $timeout, dpText, dpHelper) {
		$scope.formData = {
			file_cover_count: 1,
			self_adhesive_box_count: 1,
			cd_dvd_count: 1,
			cd_dvd_cover_count: 1,
			cd_dvd_burn_enabled: "0",
			cd_dvd_burn_medium: '',
			mkh_count_mono: 0,
			mkh_count_color: 0,
			mkh_count_combi: 0,
			mkh_print_type: "0",
			mmv_count_mono: 0,
			mmv_count_color: 0,
			mmv_count_combi: 0,
			mmv_print_type: "0",
			ucs_count_mono: 0,
			ucs_count_color: 0,
			ucs_count_combi: 0,
			ucs_title: 0,
			ucs_print_type: "0",
			gift_enabled: 0,
			gift_id: 0,
            package_with_print_count: 1
		};
		$scope.minCount = 1;
        $scope.disable_expres = 0;
        $scope.disable_superexpres = 0;
        $scope.adminExpresInfo = null;

		$scope.cdDvdBurnFiles = [];
		$scope.removeCdDvdPrint = removeCdDvdPrint;
		$scope.removeBurnFile = removeBurnFile;
        $scope.removePackageWithPrintFile = removePackageWithPrintFile;

		function initialize() {
			$http.post('/diplomovky/fast_ajax/getAccessoryData')
				.then(initializeSuccess);
		}

		function initializeSuccess(response) {
			$scope.sessionData = response.data.sessionData;
			setDefaults($scope.sessionData);
			$scope.sessionId = response.data.sessionData.session_id;
			getDeliveries();

			$scope.txt = response.data.texts;
			dpText.set($scope.txt);
			dpHelper.step = response.data.step;

			$scope.mkhColors = response.data.mkhColors;
			$scope.mmvColors = response.data.mmvColors;
			$scope.ucsColors = response.data.ucsColors;
			$scope.isOperator = $scope.sessionData.is_operator;
			$scope.factoryPlaces = response.data.factoryPlaces;

			$scope.settings = response.data.settings;
			$scope.binding = response.data.binding;
			$scope.bindingUcs = response.data.bindingUcs;
			$scope.sections = response.data.sections;
			$scope.gifts = response.data.gifts;

			if ($scope.gifts) {
				$scope.formData.gift_enabled = 1;
				$scope.formData.gift_id = $scope.gifts[0].GIFT_ID;
			}

			$scope.bindingColors = response.data.bindingColors;
			$scope.bindingFontColors = response.data.bindingFontColors;
			$scope.bindingBackColors = response.data.bindingBackColors;

			$scope.dpHelper = dpHelper;
			$scope.voucher = dpHelper.getVoucherData($scope.sessionData);
			$scope.minCount = dpHelper.getMinimumCount($scope.voucher, $scope.minCount);
			$scope.cdDvdPrintFile = $scope.sessionData.cd_dvd_print_file;
			$scope.cdDvdBurnFiles = $scope.sessionData.cd_dvd_burn_files || [];
			$scope.burnMedia = null;
            $scope.packageWithPrintFiles = $scope.sessionData.package_with_print_files || [];
			getStores($scope.formData.binding, $scope.formData.binding_processing, $scope.formData.city, false);

			initCdDvdPrintUpload($scope.sessionId);
			initCdDvdBurnUpload($scope.sessionId);
            initPackageWithPrintUpload($scope.sessionId);
            $scope.coverSvg = response.data.coverSvg;

			$scope.cities = response.data.cities;
			$scope.courierDeliveryTime = response.data.courierDeliveryTime;
            $scope.deliveryTime = '';
            getDeliveryTime();
			if ($scope.cities.length === 0) {
				Alert.alert(dpText.get('DP_NEKOMPATIBILNE_DORUCENIE_S_KOSIKOM'));
			}

			dpHelper.refreshSelectpickers($scope);

			$timeout(function() {
				$scope.$watch('formData.count', refreshPriceDataWatch);

				$scope.$watch('formData.optional_binding_enabled', refreshPriceDataAndSelectpickerWatch);

				$scope.$watch('formData.mkh_enabled', refreshPriceDataAndSelectpickerWatch);
				$scope.$watch('formData.mkh_color_id', refreshPriceDataAndSelectpickerWatch);
				$scope.$watch('formData.mkh_count_mono', refreshPriceDataAndSelectpickerWatch);
				$scope.$watch('formData.mkh_count_color', refreshPriceDataAndSelectpickerWatch);
				$scope.$watch('formData.mkh_count_combi', refreshPriceDataAndSelectpickerWatch);
				$scope.$watch('formData.mkh_print_type', refreshPriceDataAndSelectpickerWatch);

				$scope.$watch('formData.mmv_enabled', refreshPriceDataAndSelectpickerWatch);
				$scope.$watch('formData.mmv_color_id', refreshPriceDataAndSelectpickerWatch);
				$scope.$watch('formData.mmv_count_mono', refreshPriceDataAndSelectpickerWatch);
				$scope.$watch('formData.mmv_count_color', refreshPriceDataAndSelectpickerWatch);
				$scope.$watch('formData.mmv_count_combi', refreshPriceDataAndSelectpickerWatch);
				$scope.$watch('formData.mmv_print_type', refreshPriceDataAndSelectpickerWatch);

				$scope.$watch('formData.ucs_enabled', refreshPriceDataAndSelectpickerWatch);
				$scope.$watch('formData.ucs_color_id', refreshPriceDataAndSelectpickerWatch);
				$scope.$watch('formData.ucs_count_mono', refreshPriceDataAndSelectpickerWatch);
				$scope.$watch('formData.ucs_count_color', refreshPriceDataAndSelectpickerWatch);
				$scope.$watch('formData.ucs_count_combi', refreshPriceDataAndSelectpickerWatch);
				$scope.$watch('formData.ucs_title', refreshPriceDataAndSelectpickerWatch);
				$scope.$watch('formData.ucs_print_type', refreshPriceDataAndSelectpickerWatch);

				$scope.$watch('formData.file_cover_enabled', refreshPriceDataAndSelectpickerWatch);
				$scope.$watch('formData.file_cover_count', refreshPriceDataWatch);
				$scope.$watch('formData.file_cover_sticker_enabled', refreshPriceDataAndSelectpickerWatch);
				$scope.$watch('formData.self_adhesive_box_enabled', refreshPriceDataWatch);
				$scope.$watch('formData.self_adhesive_box_count', refreshPriceDataWatch);
				$scope.$watch('formData.enhanced_binding_enabled', refreshPriceDataWatch);

				$scope.$watch('formData.cd_dvd_enabled', refreshCdDvdWatch);
				$scope.$watch('formData.cd_dvd_type', refreshCdDvdTypeWatch);
				$scope.$watch('formData.cd_dvd_count', refreshPriceDataWatch);
				$scope.$watch('formData.cd_dvd_burn_enabled', refreshCdDvdBurnWatch);
				$scope.$watch('formData.cd_dvd_print_type', refreshPriceDataWatch);

				$scope.$watch('formData.cd_dvd_type', burnMediumWatch);
				$scope.$watch('formData.cd_dvd_print_type', burnMediumWatch);
				$scope.$watch('formData.cd_dvd_burn_enabled', burnMediumWatch);
				$scope.$watch('formData.cd_dvd_burn_medium', refreshPriceDataWatch);

				$scope.$watch('formData.cd_dvd_cover_enabled', refreshPriceDataWatch);
				$scope.$watch('formData.cd_dvd_cover_count', refreshPriceDataWatch);

				$scope.$watch('formData.gift_enabled', refreshPriceDataWatch);
				$scope.$watch('formData.gift_id', refreshPriceDataWatch);

				$scope.$watch('formData.delivery_id', refreshDeliveryIdWatch);
				$scope.$watch('formData.city', cityWatch);
				//$scope.$watch('formData.store_id', refreshPriceDataWatch);
                $scope.$watch('formData.store_id', function(newValue, oldValue){
                    refreshPriceDataWatch(newValue, oldValue);
                    getDeliveryTime();
                });
				// $scope.$watch('formData.operator_fee', refreshPaymentMethod);
				$scope.$watch('formData.operator_fee', refreshPriceDataWatch);
				//$scope.$watch('formData.is_expres', refreshPriceDataWatch);
                $scope.$watch('formData.is_expres', function(newValue, oldValue){
                    if(newValue == 1) $scope.formData.is_superexpres = 0;
                    refreshPriceDataWatch(newValue, oldValue);
                    getDeliveryTime();
                });
                $scope.$watch('formData.is_superexpres', function(newValue, oldValue){
                    if(newValue == 1) $scope.formData.is_expres = 0;
                    refreshPriceDataWatch(newValue, oldValue);
                    getDeliveryTime();
                });
                $scope.$watch('formData.package_with_print_enabled', refreshPackageWithPrintWatch);
                $scope.$watch('formData.package_with_print_count', refreshPriceDataWatch);
                $scope.$watch('formData.package_with_print_type', refreshPackageWithPrintTypeWatch);

			});

			//aby načítalo express cenu
			refreshPriceDataWatch(0,1);

			function refreshPriceDataWatch(newValue, oldValue) {
				if (newValue !== oldValue) {
					dpHelper.refreshPriceData($scope.formData, function(priceData){
						$scope.priceData = priceData;
						getDeliveries();
					});
				}
			}

			// function refreshPaymentMethod(newValue, oldValue) {
			// 	if (newValue !== oldValue) {
			// 		if ($scope.formData.payment_mode === 'eshop' && newValue === 1) {
			// 			Session.set('payment_mode', 'predajna', function () {
			// 				$scope.formData.payment_mode = 'predajna';
			// 				refreshPriceDataWatch(0,1);
			// 			});
			// 		} else if ($scope.formData.payment_mode === 'predajna' && newValue === 0) {
			// 			Session.set('payment_mode', 'eshop', function () {
			// 				$scope.formData.payment_mode = 'eshop';
			// 				refreshPriceDataWatch(0,1);
			// 			});
			// 		}
			// 	}
			// }

			function refreshPriceDataAndSelectpickerWatch(newValue, oldValue) {
				refreshPriceDataWatch(newValue, oldValue);
				refreshSelectpicker();
			}

			function refreshDeliveryIdWatch(newValue, oldValue) {
				if (oldValue === '1' && newValue !== oldValue) {
					delete $scope.formData.city;
					delete $scope.formData.store_id;
					$scope.formData.is_expres = 0;
                    $scope.formData.is_superexpres = 0;

					Session.unset(['city', 'store_id'], function(){
						Session.set('is_expres', 0, function() {
                            Session.set('is_superexpres', 0, function () {
                                refreshPriceDataAndSelectpickerWatch(newValue, oldValue);
                            });
                        });
					});
				} else {
					refreshPriceDataAndSelectpickerWatch(newValue, oldValue);
				}
                getDeliveryTime();
			}

			function refreshCdDvdWatch(newValue, oldValue) {
				refreshPriceDataAndSelectpickerWatch(newValue, oldValue);
				disableUploadButton('#uploadifive-cd-dvd-print-file', newValue === 0);
				disableUploadButton('#uploadifive-cd-dvd-burn-files', newValue === 0 || $scope.formData.cd_dvd_burn_enabled === '0');
			}

            function refreshPackageWithPrintWatch(newValue, oldValue) {
                refreshPriceDataAndSelectpickerWatch(newValue, oldValue);
                refreshPackageWithPrintTypeWatch(newValue, oldValue);
            }

            function refreshPackageWithPrintTypeWatch(newValue, oldValue) {
                disableUploadButton('#uploadifive-package-with-print-files', $scope.formData.package_with_print_type !== 'file');
                if(newValue != oldValue) Session.set('package_with_print_type', newValue);
            }

			function refreshCdDvdTypeWatch(newValue, oldValue) {
				refreshPriceDataAndSelectpickerWatch(newValue, oldValue);
				// if (newValue !== undefined) {
				// 	disableUploadButton('#uploadifive-cd-dvd-print-file', newValue.indexOf('printable') === -1);
				// }
			}

			function refreshCdDvdBurnWatch(newValue, oldValue) {
				refreshPriceDataAndSelectpickerWatch(newValue, oldValue);

				// pridanie súborov obsahu a prílohy, ak sú dostupné
				if (newValue == 1 && oldValue !== newValue) {
					$http.get('/diplomovky/fast_ajax/addDefaultBurnFiles')
						.then(successAddDefaultBurnFiles);
				}

				function successAddDefaultBurnFiles(response) {
					if (response.data) {
						$scope.cdDvdBurnFiles = response.data;
					}
				}

				if (newValue !== undefined) {
					disableUploadButton('#uploadifive-cd-dvd-burn-files', newValue === '0' || !newValue);
				}
			}

			function disableUploadButton(element, expression) {
				if (expression) {
					$(element).attr('disabled', 'disabled');
					$(element + ' input').attr('disabled', 'disabled');
				} else {
					$(element).removeAttr('disabled');
					$(element + ' input').removeAttr('disabled');
				}
			}

			function cityWatch(newValue, oldValue) {
				if (newValue !== oldValue) {
					getStores($scope.formData.binding, $scope.formData.binding_processing, $scope.formData.city, true);
				}
			}

			function burnMediumWatch() {
				$http({
					method: 'GET',
					url: '/diplomovky/fast_ajax/getBurnMedium',
					params: {
						type: $scope.formData.cd_dvd_type,
						print_type: $scope.formData.cd_dvd_print_type,
						burn_enabled: $scope.formData.cd_dvd_burn_enabled
					}
				}).then(function (response) {
					$scope.burnMedia = response.data;

					$timeout(function() {
						refreshSelectpicker();
					});
				});
			}
		}

		function getDeliveries() {
			$http.get('/diplomovky/fast_ajax/getTotalWeight').then(getTotalWeightSuccess);

			function getTotalWeightSuccess(response) {
				var heightKg = parseFloat(response.data) / 1000;
				$http.get('/ajax/getDeliveries/301/' + heightKg).then(getDeliveriesSuccess);
			}

			function getDeliveriesSuccess(response) {
				if ($scope.formData.binding_processing === 'cover_only') {
					angular.forEach(response.data, function(delivery, key){
						if (delivery.ID !== 1) {
							delete response.data[key];
						}
					});
				}

				$scope.deliveries = response.data;
				dpHelper.refreshSelectpicker('formData.delivery_id', $scope);
			}
		}

		function getStores(binding, processing, city, removeStoreId) {
			$http({
				method: 'GET',
				url: '/diplomovky/fast_ajax/getStores',
				params: {
					city: city
				}
			}).then(AjaxStoresSuccess);

			function AjaxStoresSuccess(response) {
				console.log(response);
				if (removeStoreId) {
					delete $scope.formData.store_id;
				}

				$scope.stores = response.data;

				dpHelper.refreshSelectpicker('formData.store_id', $scope);
			}
		}

		function setDefaults(session) {
			var defaults = {
				binding: 'string',
				binding_processing: 'string',
				payment_mode: 'string',
				binding_color_id: 'string',
				binding_font_color_id: 'string',
				list_count_content: 'int',
				list_count_attach: 'int',
				paper_mode_content: 'int',
				paper_mode_attach: 'int',
				count: 'int',

				optional_binding_enabled: 'int',

				mph_enabled: 'int',

				mkh_enabled: 'int',
				mkh_color_id: 'string',
				mkh_count_mono: 'int',
				mkh_count_color: 'int',
				mkh_count_combi: 'int',
				mkh_print_type: 'string',

				mmv_enabled: 'int',
				mmv_color_id: 'string',
				mmv_count_mono: 'int',
				mmv_count_color: 'int',
				mmv_count_combi: 'int',
				mmv_print_type: 'string',

				ucs_enabled: 'int',
				ucs_color_id: 'string',
				ucs_count_mono: 'int',
				ucs_count_color: 'int',
				ucs_count_combi: 'int',
				ucs_title: 'int',
				ucs_print_type: 'string',

				empty_sheet_enabled: 'int',
				file_cover_enabled: 'int',
				file_cover_count: 'int',
				file_cover_sticker_enabled: 'int',
				file_cover_sticker_print: 'string',
				file_cover_sticker_text: 'string',
				self_adhesive_box_enabled: 'int',
				self_adhesive_box_count: 'int',
				enhanced_binding_enabled: 'int',
                package_with_print_enabled: 'int',
                package_with_print_count: 'int',
                package_with_print_type: 'string',

				cd_dvd_enabled: 'int',
				cd_dvd_type: 'string',
				cd_dvd_count: 'int',
				cd_dvd_print_type: 'string',
				cd_dvd_print_text: 'string',
				cd_dvd_burn_enabled: 'string',
				cd_dvd_burn_later: 'int',
				cd_dvd_unpack_files: 'int',
				cd_dvd_burn_medium: 'string',

				cd_dvd_cover_enabled: 'int',
				cd_dvd_cover_count: 'int',

				gift_enabled: 'int',
				gift_id: 'int',
				
				delivery_id: 'string',
				city: 'string',
				store_id: 'string',
				is_expres: 'int',
                is_superexpres: 'int',
				operator_fee: 'int',
				factory_place: 'string',
				note: 'string',
                deliveryTime: 'string',
                paper_content: 'int',
                paper_attach: 'int',
			};

			for (var key in defaults) {
				var type = defaults[key];
				var value = session[key];

				if (typeof value === 'undefined') {
					continue;
				}

				if (type === 'int') {
					value = parseInt(value);
				}

				if (type === 'bool') {
					value = (value !== 'false' && value) ? true : false;
				}

				$scope.formData[key] = value;
			}
		}

		function refreshSelectpicker() {
			//timeout sa spustí až po renderi viewu
			$timeout(function() {
		    	$('select').selectpicker('refresh');
			});
		}

		function initCdDvdPrintUpload(sessionId) {

			$('#cd-dvd-print-file').uploadifive({
	            uploadScript: '/diplomovky/fast_ajax/uploadFile',
	            buttonText: $scope.txt.DP_NAHRAT,
	            //fileType: 'application/pdf',
	            auto: true,
	            multi: false,
	            buttonClass: 'btn btn-success col-md-6',
	            removeCompleted: true,
	            formData: {
	                session_id: sessionId,
	                title: 'cddvd_print',
	            },
	            onUpload: function() {
	            	var html = '<div class="progress">';
	            	html += '<div class="progress-bar progress-bar-striped active progress-upload-file" role="progressbar" style="width: 0%">';
	            	html += '<span class="sr-only">45% Complete</span>';
	            	html += '</div>';
	            	html += '</div>';

	            	Alert.loader(true, dpText.get('DP_VAS_SUBOR_SA_NAHRAVA') + html);
	            },
	            onUploadComplete: function(file, json_data) {
	            	var data = JSON.parse(json_data);
	            	console.log(data);

	            	$scope.$apply(function () {
            			if (data.result) {
            				$scope.cdDvdPrintFile = data;
            				Session.set('cd_dvd_print_file', data);
            			} else {
            				delete $scope.cdDvdPrintFile;
            				Session.unset('cd_dvd_print_file');
            			}
			        });

	            	Alert.loader(false);
	            },
	            onUploadError: function(error) {
	                console.log(error);
	            },
	            onError: function(errorType) {
	            	if (errorType == 'FORBIDDEN_FILE_TYPE') {
	            		Alert.alert(dpText.get('DP_3_DVD_TXT_NEPLATNY_TYP_SUBORU'));
	            		setTimeout(function(){
	            			Alert.loader(false);
	            		}, 300);
	            	}
	            },
				onInit: function() {
					$('.uploadifive-button').each(function(index, el) {
						var $button = $(this).find('button[title]');

						if ($button.length) {
							var title = $button.attr('title');
							$(this).attr('title', title).tipTip();
						}
					});
					$('.uploadifive-button').removeAttr('style').removeClass('uploadifive-button').addClass('module-uploadifive-button');
				},
				onProgress: function(file, e) {
		            if (e.lengthComputable) {
		                var percent = Math.round((e.loaded / e.total) * 100);

		            	$('.progress-upload-file').css('width', percent+'%');
		            	$('.progress-upload-file').html(percent+' %');
		            }
		        }
	        });
		}

        function initPackageWithPrintUpload(sessionId) {

            $('#package-with-print-files').uploadifive({
                uploadScript: '/diplomovky/fast_ajax/uploadPackageWithPrintFiles',
                buttonText: $scope.txt.DP_NAHRAT,
                //fileType: 'application/pdf',
                auto: true,
                multi: true,
                buttonClass: 'btn btn-success col-md-12 btn-sm',
                removeCompleted: true,
                formData: {
                    session_id: sessionId
                },
                onUpload: function() {
                    var html = '<div class="progress">';
                    html += '<div class="progress-bar progress-bar-striped active progress-upload-file" role="progressbar" style="width: 0%">';
                    html += '<span class="sr-only">45% Complete</span>';
                    html += '</div>';
                    html += '</div>';

                    Alert.loader(true, dpText.get('DP_VAS_SUBOR_SA_NAHRAVA') + html);
                },
                onUploadComplete: function(file, json_data) {
                    var data = JSON.parse(json_data);
                    console.log(data);

                    $scope.$apply(function () {
                        if (data.result) {
                            $scope.packageWithPrintFiles.push(data);
                            Session.set('package_with_print_files[]', data);
                        }
                    });

                    Alert.loader(false);
                },
                onUploadError: function(error) {
                    console.log(error);
                },
                onError: function(errorType) {
                    if (errorType == 'FORBIDDEN_FILE_TYPE') {
                        Alert.alert(dpText.get('DP_3_DVD_TXT_NEPLATNY_TYP_SUBORU'));
                        setTimeout(function(){
                            Alert.loader(false);
                        }, 300);
                    }
                },
                onInit: function() {
                    $('.uploadifive-button').each(function(index, el) {
                        var $button = $(this).find('button[title]');

                        if ($button.length) {
                            var title = $button.attr('title');
                            $(this).attr('title', title).tipTip();
                        }
                    });
                    $('.uploadifive-button').removeAttr('style').removeClass('uploadifive-button').addClass('module-uploadifive-button');
                },
                onProgress: function(file, e) {
                    if (e.lengthComputable) {
                        var percent = Math.round((e.loaded / e.total) * 100);

                        $('.progress-upload-file').css('width', percent+'%');
                        $('.progress-upload-file').html(percent+' %');
                    }
                }
            });
        }

		function removeCdDvdPrint() {
			$http.post('/diplomovky/fast_ajax/removeCdDvdPrint').then(onSuccessRemoveCdDvdPrint);

			function onSuccessRemoveCdDvdPrint() {
				delete $scope.cdDvdPrintFile;
				Session.unset('cd_dvd_print_file');
			}
		}

        function removePackageWithPrintFile(filename) {
            $http.post('/diplomovky/fast_ajax/removePackageWithPrintFile', $.param({filename: filename})).then(removePackageWithPrintFile);

            function removePackageWithPrintFile(response) {
                angular.forEach($scope.packageWithPrintFiles, function(file, key){
                    if (file.basename === filename) {
                        $scope.packageWithPrintFiles.splice(key, 1);
                    }
                });
            }
        }

		function initCdDvdBurnUpload(sessionId) {

			$('#cd-dvd-burn-files').uploadifive({
	            uploadScript: '/diplomovky/fast_ajax/uploadBurnFiles',
	            buttonText: $scope.txt.DP_NAHRAT,
	            //fileType: 'application/pdf',
	            auto: true,
	            multi: true,
	            buttonClass: 'btn btn-success col-md-12 btn-sm',
	            removeCompleted: true,
	            formData: {
	                session_id: sessionId
	            },
	            onUpload: function() {
	            	var html = '<div class="progress">';
	            	html += '<div class="progress-bar progress-bar-striped active progress-upload-file" role="progressbar" style="width: 0%">';
	            	html += '<span class="sr-only">45% Complete</span>';
	            	html += '</div>';
	            	html += '</div>';

	            	Alert.loader(true, dpText.get('DP_VAS_SUBOR_SA_NAHRAVA') + html);
	            },
	            onUploadComplete: function(file, json_data) {
	            	var data = JSON.parse(json_data);
	            	console.log(data);

	            	$scope.$apply(function () {
            			if (data.result) {
            				$scope.cdDvdBurnFiles.push(data);
            				Session.set('cd_dvd_burn_files[]', data);
            			}
			        });

	            	Alert.loader(false);
	            },
	            onUploadError: function(error) {
	                console.log(error);
	            },
	            onError: function(errorType) {
	            	if (errorType == 'FORBIDDEN_FILE_TYPE') {
	            		Alert.alert(dpText.get('DP_3_DVD_TXT_NEPLATNY_TYP_SUBORU'));
	            		setTimeout(function(){
	            			Alert.loader(false);
	            		}, 300);
	            	}
	            },
				onInit: function() {
					$('.uploadifive-button').each(function(index, el) {
						var $button = $(this).find('button[title]');

						if ($button.length) {
							var title = $button.attr('title');
							$(this).attr('title', title).tipTip();
						}
					});
					$('.uploadifive-button').removeAttr('style').removeClass('uploadifive-button').addClass('module-uploadifive-button');
				},
				onProgress: function(file, e) {
		            if (e.lengthComputable) {
		                var percent = Math.round((e.loaded / e.total) * 100);

		            	$('.progress-upload-file').css('width', percent+'%');
		            	$('.progress-upload-file').html(percent+' %');
		            }
		        }
	        });
		}

		function removeBurnFile(filename) {
			$http.post('/diplomovky/fast_ajax/removeBurnFile', $.param({filename: filename})).then(removeBurnFileSuccess);

			function removeBurnFileSuccess(response) {
				angular.forEach($scope.cdDvdBurnFiles, function(file, key){
					if (file.basename === filename) {
						$scope.cdDvdBurnFiles.splice(key, 1);
					}
				});
			}
		}

        function getDeliveryTime(){
            //console.log('spustam getDeliveryTime');
            $http.post('/diplomovky/fast_ajax/getDeliveryTime', $.param({delivery_id: $scope.formData.delivery_id, store_id: $scope.formData.store_id, is_expres: $scope.formData.is_expres, is_superexpres: $scope.formData.is_superexpres})).then(onSuccessDeliveryTime);

            function onSuccessDeliveryTime(response) {
                $scope.deliveryTime = response.data;
                zddebugger();
                isEnabledExpres();
            }
        }

        function isEnabledExpres(){
            $http.post('/ajax/isEnabledExpres').then(function(response){
                //console.log(response);
                const data = response.data;
                if(data.disable_expres == 1){
                    $scope.disable_expres = 1;
                    $scope.formData.is_expres = 0;
                }
                else{
                    $scope.disable_expres = 0;
                }
                if(data.disable_superexpres == 1){
                    $scope.disable_superexpres = 1;
                    $scope.formData.is_superexpres = 0;
                }
                else{
                    $scope.disable_superexpres = 0;
                }
                $scope.adminExpresInfo = data.adminExpresInfo;
            });
        }

		angular.element(document).ready(function () {
			initialize();
	    });
	}
}());
